import { render, staticRenderFns } from "./LyricSearch.vue?vue&type=template&id=548baada&scoped=true"
import script from "./LyricSearch.vue?vue&type=script&lang=js"
export * from "./LyricSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548baada",
  null
  
)

export default component.exports